// free-video.ts -- (session 10, A7) kept apart from client.ts (which reads Vite env at load), so it is testable on its own.
/**
 * (session 10, A7; drop 49) Revive, Retry and Skip on a run whose video's credits were already returned are refused (409),
 * because they would make it free. Asked here, once for every button: the operator sees the reason and is asked; only on a
 * yes is the call repeated with `acceptFreeVideo=1`. Never silent.
 */
export async function confirmingFreeVideo<T>(call: (query: string) => Promise<T>, ask: (text: string) => boolean = (t) => window.confirm(t)): Promise<T> {
  try { return await call(""); }
  catch (e) {
    const reason = (e as Error)?.message ?? "";
    if (!/acceptFreeVideo/.test(reason)) throw e;
    if (!ask(`${reason}\n\nRedo it anyway? It will be a FREE video: no credits are charged.`)) throw e;
    return call("?acceptFreeVideo=1");
  }
}
